module.exports = __webpack_public_path__ + "static/img/1.ce18c3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/1.jpg
// module id = /lSo
// module chunks = 14